import React, {useContext, useState} from "react";
import {downloadDoc, visualizzaAnteprimaFile} from "../../../../../utility/common";
import {LoaderContext} from "../../../../../context/LoaderContext";
import TabellaCertDocumentiFirmatiView from "./TabellaCertDocumentiFirmatiView";
import {getDocumentoFirmatoApi, inviaEmailDocumentoFirmatoApi} from "../../../../../services/CertificatiServices";

export default function TabellaCertDocumentiFirmatiController({
                                                                  documentiFirmati,
                                                                  totDocumentiFirmati,
                                                                  handlerUpdateCertificati,
                                                              }) {

    const [showMsg, setShowMsg] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function downloadDocFirmato(row, download) {
        startChiamata();

        const response = await getDocumentoFirmatoApi(row.id_certificato, {
            download: '1'
        });
        endChiamata();
        if (response.data.result == -1) {
            setModalMsg(response.data.description)
            setShowMsg(true)
        } else {
            let resp = response.data.data;
            if (resp) {
                if (download === true) {
                    downloadDoc(resp)
                } else {
                    const contentType = resp.content_type;
                    const base64Data = resp.contenuto;

                    visualizzaAnteprimaFile(base64Data, contentType);
                }
            }
        }
    }

    async function inviaEmailDocumentoFirmatoCert(idCertificato) {
        startChiamata();

        const response = await inviaEmailDocumentoFirmatoApi(idCertificato);
        setModalMsg(response.data.description);
        setShowMsg(true);
        if (response.data.result == '0') {
            handlerUpdateCertificati();
        }
        endChiamata();
    }

    return (
        <TabellaCertDocumentiFirmatiView
            documentiFirmati={documentiFirmati}
            downloadDocFirmato={downloadDocFirmato}
            setShowMsg={setShowMsg}
            totDocumentiFirmati={totDocumentiFirmati}
            showMsg={showMsg}
            modalMsg={modalMsg}
            inviaEmailDocumentoFirmatoCert={inviaEmailDocumentoFirmatoCert}
        />
    );

}